<template>
    <v-row>
        <v-col cols="12">
            <div class="text-h5 font-weight-bold mb-2">{{ $t('referrers.your_payouts') }}</div>
            <div class="text-body-2">{{ $t('referrers.keep_track') }}</div>
            <v-row
                class="mt-3"
                :class="!payouts ||(payouts && payouts.length < 1)? 'blur':''"
                no-gutters>
                <v-col cols="4">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.date') }}</span>
                </v-col>
                <v-col cols="4" class="text-center">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.referrals') }}</span>
                </v-col>
                <v-col cols="4" class="text-end">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.amount') }}</span>
                </v-col>
                <template v-for="payout in payouts">
                    <v-col cols="4" class="my-3">
                        <span class="text-caption">{{payout.date}}</span>
                    </v-col>
                    <v-col cols="4" class="text-center my-3">
                        <span class="text-caption">{{payout.name}}</span>
                    </v-col>
                    <v-col cols="4" class="text-end my-3">
                        <span class="text-caption">{{payout.amount}}</span>
                    </v-col>
                    <v-col cols="12"> <v-divider/></v-col>
                </template>
                <template v-if="!payouts ||(payouts && payouts.length < 1)">
                    <v-col cols="4" class="my-3">
                        <span class="text-caption">May 2023</span>
                    </v-col>
                    <v-col cols="4" class="text-center my-3">
                        <span class="text-caption">Stefan G. , Bert T.</span>
                    </v-col>
                    <v-col cols="4" class="text-end my-3">
                        <span class="text-caption">500 EUR</span>
                    </v-col>
                </template>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: "PayoutsDashboard",
  props: [
      'payouts',
  ],
}
</script>

<style lang="scss">
.blur {
  filter: blur(5px);
}
</style>
